import { render, staticRenderFns } from "./FormDetail.vue?vue&type=template&id=0c17444e&scoped=true&"
import script from "./FormDetail.vue?vue&type=script&lang=js&"
export * from "./FormDetail.vue?vue&type=script&lang=js&"
import style0 from "./FormDetail.vue?vue&type=style&index=0&id=0c17444e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c17444e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c17444e')) {
      api.createRecord('0c17444e', component.options)
    } else {
      api.reload('0c17444e', component.options)
    }
    module.hot.accept("./FormDetail.vue?vue&type=template&id=0c17444e&scoped=true&", function () {
      api.rerender('0c17444e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/knowledge/FormDetail.vue"
export default component.exports